export class FetchError extends Error {
  status: number;

  constructor(status: number, message?: string) {
    super(message || "FetchError");
    this.status = status;
  }
}
